import { Link } from "react-router-dom";
import { AuthLayout } from "../components/AuthLayout";

export default function NotFound() {
  return (
    <AuthLayout testId="not-found-page" eyebrow="404" title="Page not found" subtitle="The page you are looking for does not exist.">
      <Link to="/login" data-testid="not-found-home-link" className="font-semibold text-[#7A0016] hover:underline">Go to sign in</Link>
    </AuthLayout>
  );
}
